import { render } from "./AdminNotices.vue?vue&type=template&id=57c01564"
import script from "./AdminNotices.vue?vue&type=script&lang=js"
export * from "./AdminNotices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__